import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CART_UPDATED } from '@outdoor-voices/ui/dist/config/constants';
import { CART_URLS } from '../../apps/cart/constants';
import { JSON_HEADERS, POST_HEADERS } from '../../config/constants';
import { SIZES_EXTENDED, SIZE_NAME_MAP } from '../../config/constants-sizes';
import { retailAddToCart } from '../retail';
import { trackAddToCart } from './addTracker';

var addToCart = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var emsColorwayGid, emsProductGid, price, title, variantId, hasBag, body, loadingEvent, headers, addRequest, addResponse, cartRequest, cartResponse, options, newOptions, added, event;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            emsColorwayGid = _ref.emsColorwayGid, emsProductGid = _ref.emsProductGid, price = _ref.price, title = _ref.title, variantId = _ref.variantId;
            hasBag = document.querySelector('#ov-bag');
            body = {
              id: variantId,
              properties: {
                _emsColorwayGid: emsColorwayGid,
                _emsProductGid: emsProductGid
              },
              quantity: 1
            };

            if (hasBag) {
              // trigger event for loading-state bag before fetch...
              loadingEvent = new CustomEvent(CART_UPDATED, {
                detail: {
                  added: false,
                  loading: true,
                  cartItems: [],
                  items: false
                }
              });
              window.dispatchEvent(loadingEvent);
            }

            headers = _objectSpread(_objectSpread({}, POST_HEADERS), {}, {
              credentials: 'same-origin'
            });
            _context.next = 7;
            return fetch(CART_URLS.ADD, _objectSpread(_objectSpread({}, headers), {}, {
              body: JSON.stringify(body)
            }));

          case 7:
            addRequest = _context.sent;
            _context.next = 10;
            return addRequest.json();

          case 10:
            addResponse = _context.sent;
            trackAddToCart({
              variantId: variantId,
              title: title,
              price: price
            }); // fetch the cart from Shopify because it doesn't return the total count

            _context.next = 14;
            return fetch(CART_URLS.GET, JSON_HEADERS);

          case 14:
            cartRequest = _context.sent;
            _context.next = 17;
            return cartRequest.json();

          case 17:
            cartResponse = _context.sent;
            // Track the add to cart in the retail API
            retailAddToCart({
              cartToken: cartResponse.token,
              variantId: variantId
            }); // If the bag component is present, we can display the add to bag.

            if (hasBag) {
              // Update the size to use a more verbose version than what shopify sends back
              options = addResponse.variant_options;
              newOptions = options;

              if (options.length > 1 && SIZES_EXTENDED.indexOf(options[1] > -1)) {
                newOptions[1] = SIZE_NAME_MAP[options[1]];
              }

              added = _objectSpread(_objectSpread({}, addResponse), {}, {
                variant_options: newOptions
              }); // trigger event for bag

              event = new CustomEvent(CART_UPDATED, {
                detail: {
                  added: added,
                  cartItems: cartResponse.items,
                  loading: false,
                  items: cartResponse.item_count
                }
              });
              window.dispatchEvent(event);
            } else {
              // Otherwise just head to the cart.
              window.location.assign('/cart');
            }

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addToCart(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export default addToCart;